import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Rx';

@Injectable()
export class LoadingSpinnerService {
  public spinner$: Subject<number>;

  constructor () {
    this.spinner$ = new Subject<number>();
  }

  public start(percentage?: number) {
    this.spinner$.next(percentage ? percentage : 1);
  }

  public stop() {
    this.spinner$.next(0);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/loading-spinner/loading-spinner.service.ts